import base from './base'

export const get = (biid: string) => {
  return base.get(`/v1/fixed_assets/${biid}/annual_depreciation`)
}
